<template>
	<footer class="footer footer-small footer-color-black" data-color="black">
	    <div class="container">
	    	<div class="row">
	    		<div class="col-xs-12 col-sm-6 col-md-6">
	    			<h2 class="text-center">About</h2>

	    			<p class="text-justify">Ezifood is a product of Ezitek Solutions. It is a web and mobile application that allows you to order food from your favourite restaurants in simple and easy steps.</p>

	    			<h2 class="text-center large-margin-top">Get In Touch</h2>
	    			<p><b>Email:</b> <a id="info-mail-link" href="mailto:info@ezifood.com">info@ezifood.com</a></p>
	    			<p><b>Phone:</b> 054 204 3151</p>
	    			<p><b>Location:</b> KNUST - Kumasi</p>
	    		</div>

	    		<div class="col-xs-12 col-sm-6 col-md-6">
	    			<h2 class="text-center">Contact</h2>

					<!-- Email field -->
					<form @submit.prevent="sendUserMessage">
						<div class="form-group" :class="{ 'has-error': errors.has('email') }">
	                        <label for="email">Email</label>

							<input 
								type="text" 
								id="email" 
								name="email" 
								v-model="contactUs.email" 
								class="form-control" 
								v-validate="rules.email"
								placeholder="user@ezifood.com">

							<error-label :show="errors.has('email')">{{ errors.first('email') }}</error-label>
	                    </div>

						<!-- Phone field -->
						<div class="form-group" :class="{ 'has-error': errors.has('phone') }">
	                        <label for="phone">Phone</label>

							<input 
								type="text" 
								id="phone" 
								name="phone" 
								v-model="contactUs.phone" 
								class="form-control" 
								v-validate="rules.phone"
								placeholder="0241000111">

							<error-label :show="errors.has('phone')">{{ errors.first('phone') }}</error-label>
	                    </div>

						<!-- Message field -->
						<div class="form-group" :class="{ 'has-error': errors.has('message') }">
	                        <label for="message">Message</label>

	                        <textarea
								id="message" 
								name="message" 
								v-model="contactUs.message" 
								class="form-control" 
								v-validate="rules.message"
								placeholder="Ezifood is the best"></textarea>

							<error-label :show="errors.has('message')">{{ errors.first('message') }}</error-label>
						</div>

						<div class="text-center margin-top-bottom">
							<button type="submit" class="btn btn-default btn-white">Contact Us</button>
						</div>
					</form>
	    		</div>
	    	</div>

	        <div class="copyright">
	            &copy; {{ currentYear }} - Ezifood - A product of Ezitek Solutions
	        </div>
	    </div>
	</footer>
</template>

<script>
	import { mapActions } from 'vuex';

	export default {
		data() {
			return {
				currentYear: new Date().getFullYear(),

				rules: {
					email: 'required|email',
					'phone': 'required|min:10',
					'message': 'required'
				},

				contactUs: {
					email: '',
					phone: '',
					message: '',
				}
			}
		}, 

		methods: {
			...mapActions({
				sendMessage: 'User/sendMessage'
			}),

			/**
			 * Resets contact form and also clear form errors.
			 * 
			 * @return null
			 */
			resetForm() {
				this.contactUs.email = '';
				this.contactUs.phone = '';
				this.contactUs.message = '';

				this.$nextTick(() => {
					this.errors.clear();					
				});
			},

			/**
			 * Send user's message.
			 * 
			 * @return null
			 */
			sendUserMessage() {
				this.showLoader();
				this.$validator.validateAll()
					.then(() => this.sendMessage(this.contactUs))
					.then((response) => {
						this.resetForm();

						this.notify({
							message: 'Your message was sent successfully.',
							type: 'success'
						});
					})
					.catch((errors) => {				
						this.buildErrorMessages(errors)
							.then((data) => {
								this.notify({
									message: data,
									type: 'danger'
								});
							});
					})
					.then(() => this.hideLoader());			
			}
		}
	}
</script>

<style scoped>
	footer {
		padding-top: 30px;
	}

	.row {
		border-bottom: 1px white solid;
	}

	#info-mail-link {
		color: white;
		opacity: 0.7;
	}

	#info-mail-link:hover {
		opacity: 1;
	}
</style>


// WEBPACK FOOTER //
// Footer.vue?0d19431c